import Vue from 'vue'
import App from './App'
import router from './router'
import VueSocketIO from 'vue-socket.io'
import moment from 'moment'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)
Vue.use(VueSocketIO, 'https://odc.tennis-score.ovh')
// Vue.use(VueSocketIO, 'http://odc-backend-dev.eu-west-3.elasticbeanstalk.com/')
// Vue.use(VueSocketIO, 'http://localhost:8080')

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format('DD-MM-YYYY')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js